import React from 'react';
import { motion } from 'framer-motion';
import { Zap, DollarSign, UserCheck, ThumbsUp, MapPin } from 'lucide-react';
import { useT } from '../utils/i18n';
export function WhyUs() {
  const t = useT();
  const features = [{
    title: t('why.feat1.title'),
    description: t('why.feat1.desc'),
    icon: Zap
  }, {
    title: t('why.feat2.title'),
    description: t('why.feat2.desc'),
    icon: DollarSign
  }, {
    title: t('why.feat3.title'),
    description: t('why.feat3.desc'),
    icon: UserCheck
  }, {
    title: t('why.feat4.title'),
    description: t('why.feat4.desc'),
    icon: ThumbsUp
  }];
  return <section className="py-16 dark:bg-[#3d3a3a] transition-colors duration-300 border-y border-stone-200 dark:border-[#353333] bg-[#FAF6ED]" id="why-us" data-id="element-1359">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1360">
        {/* Locally Owned intro */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mb-12" data-id="element-1361">
          <div className="flex items-center gap-2 mb-3" data-id="element-1362">
            <MapPin className="w-4 h-4 text-brand-orange" data-id="element-1363" />
            <span className="text-xs font-bold text-brand-orange uppercase tracking-widest" data-id="element-1364">
              {t('why.localOwned')}
            </span>
          </div>
          <p className="text-brand-charcoal/80 dark:text-white/80 text-base sm:text-lg leading-relaxed sm:leading-loose font-sub font-semibold max-w-3xl" data-id="element-1365">
            {t('why.localBody')}
          </p>
        </motion.div>

        {/* Feature cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1366">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="flex flex-col items-center text-center px-2" data-id="element-1367">
              <div className="w-10 h-10 bg-brand-dim/10 dark:bg-brand-dim/20 rounded-xl flex items-center justify-center mb-4 border border-brand-dim/20 dark:border-brand-dim/30" data-id="element-1368">
                <feature.icon className="w-5 h-5 text-brand-dim" data-id="element-1369" />
              </div>
              <h3 className="font-heading text-sm font-bold text-brand-charcoal dark:text-white mb-1" data-id="element-1370">
                {feature.title}
              </h3>
              <p className="text-brand-charcoal/60 dark:text-white/60 text-xs leading-relaxed" data-id="element-1371">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}